module.exports = __webpack_public_path__ + "static/footer_bg.fcc616e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer_bg.jpg
// module id = 812
// module chunks = 114276838955818